module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infos"
  }, [_c('remaining-time')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-359f974c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Infos.vue
// module id = 1652
// module chunks = 2